module.exports = __webpack_public_path__ + "img/bj49.407fcac0.png";